@if (clientUuid(); as clientUuid) {
	<app-sections-table [clientUuid]="clientUuid" (onSectionSelected)="onSectionSelected($event)"></app-sections-table>
}

@if (selectedSection(); as selectedSection) {
	@if (enrollment().length > 0) {
		<div>
			<app-enrollment-table
				[enrollment]="enrollment()"
				(onSaveEnrollment)="onSaveEnrollment($event)"
				[loading]="loading()"
			></app-enrollment-table>
		</div>
	}
}
